import _Button from "@material-ui/core/esm/Button";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import React from 'react';
import { Link } from 'react-router';
import { Container } from 'swag-client-common/components/ui/container';
import { instantScrollTop } from 'swag-client-common/utils/tricks';
import { EmptyList } from 'swag-client-common/components/partials/empty-list';
import { RecentlyViewedWidget } from 'swag-client-common/components/partials/recently-viewed-widget';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { PRIMARY_BUTTON } from '../../../../constants/styles';
import { ProductionTimeDialogForItem } from '../../../info/production-time-dialog';
import Page from '../../../page';
import BoxBuilderSelectProductsDrawer from '../../../popups/box-builder-select-products-drawer';
import CartBoxBuilderPopup from '../../../popups/cart-box-builder-popup';
import CartBoxesSpecialProductsWarningPopup from '../../../popups/cart-boxes-special-products-warning';
import CheckoutOutOfStockAdjustmentPopup from '../../../popups/checkout-out-of-stock-adjustment-popup';
import { ConfirmSharedItemsChangesDialog } from '../../../popups/confirm-cart-checkout-shared-items-changes';
import { ConfirmChangeSuperSpeedProdTimePopup } from '../../../popups/confirm-change-super-speed-prod-time-popup';
import EditQuantityInCartForBuildBoxesDrawer from '../../../popups/edit-quantity-in-cart-for-build-boxes-drawer';
import { ItemsValidationConflictPopup } from '../../../popups/items-validation-conflict-popup';
import { OrderMoreAddProductsWarningPopup, OrderMoreDeleteWarningPopup, OrderMoreEditBoxWarningPopup, OrderMoreEditQuantityWarningPopup, OrderMoreEditWarningPopup } from '../../../popups/order-more-changes-warning-popup';
import { PreventUnsavedBoxBuilderProgressPopup } from '../../../popups/prevent-unsaved-box-builder-progress-popup';
import RegularQuantityEditorPopup from '../../../popups/regular-quantity-editor-popup';
import { RemoveItemFromCartPopup } from '../../../popups/remove-item-from-cart-popup';
import RegularSizeEditorPopup from '../../../popups/sample-size-popup';
import ShareMockupDesignPopup from '../../../popups/share-mockup-design-popup';
import SizeEditorPopup from '../../../popups/size-editor-popup';
import { ConfirmTransformSuperSpeedItemsPopup } from '../../../popups/confirm-transform-super-speed-items-popup';
import { EditBoxNotecardPopup } from '../../../popups/edit-box-notecard-popup';
import { BoxNotecardPreventClosePopup } from '../../../popups/box-notecard-prevent-close-popup';
import { SuperSpeedBoxConfirmationPopup, SuperSpeedBoxTypeChangeConfirmationPopup } from '../../../popups/super-speed-box-confirmation-popup';
import { CommentPreBuiltLimitedCartPopup } from '../../../popups/comment-pre-built-limited-cart';
import { CommentPreBuiltLimitedCartSuccessPopup } from '../../../popups/comment-pre-built-limited-cart-success';
import { SuperSpeedColorLimitationPopup } from '../../../popups/super-speed-color-limitation-popup';
import BuildABoxCartButton from './components/build-a-box-cart-button';
import CheckoutBlock from './components/checkout-block';
import { LEWarning } from './components/le-warning';
import OrderItemList from './components/order-item-list';
import SavedForLaterList from './components/saved-for-later-list';
import { SuggestedProductList } from './components/suggested-product-list';
import { ItemSkeletonList } from './components/item-skeleton-list';
import { CheckoutBlockSkeleton } from './components/checkout-block-skeleton';
import { LookingForSomethingDifferent } from './components/looking-for-smth-different';
import CSSClasses from './cart.scss';
import { getHeadClasses } from './cart-classes';
const styles = {
  button: _objectSpread({}, PRIMARY_BUTTON, {
    width: '100%',
    margin: '20px 0 20px 0'
  })
};

// eslint-disable-next-line react/display-name
const AllSwagLink = /*#__PURE__*/React.forwardRef((props, ref) =>
/*#__PURE__*/
//@ts-ignore
React.createElement(Link, _extends({
  innerRef: ref,
  to: APP_ROUTES.ALL_SWAG
}, props)));
export const Cart = withStyles(styles)(({
  isCartEmpty,
  isSavedForLaterListEmpty = true,
  itemsCount,
  classes,
  isLoading,
  showEmptyPage,
  showSuggestedProductsBeforeSFL,
  showSuggestedProductsAfterSFL,
  route,
  isGreyRecentlyViewed,
  shouldShowWavedLoader
}) => {
  return /*#__PURE__*/React.createElement(Page, {
    loading: isLoading,
    autoChatbox: false,
    showCategories: false,
    showEmptyPage: showEmptyPage,
    showPhoneInMobile: true,
    doNotUseSticky: true,
    useWavedLoader: shouldShowWavedLoader
  }, /*#__PURE__*/React.createElement(Container, {
    className: classnames(CSSClasses.container, {
      [CSSClasses.withDraftItems]: !isSavedForLaterListEmpty
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(CSSClasses.cart, {
      [CSSClasses.withDraftItems]: !isSavedForLaterListEmpty
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: CSSClasses.itemsSection
  }, /*#__PURE__*/React.createElement("div", {
    className: getHeadClasses(itemsCount)
  }, /*#__PURE__*/React.createElement("h5", {
    className: CSSClasses.pageTitle
  }, "Your cart", !isLoading && /*#__PURE__*/React.createElement("span", {
    className: CSSClasses.itemsQuantity,
    "data-text": "CartItemsCount"
  }, "(", `${itemsCount}`, " ", itemsCount === 1 ? 'item' : 'items', ")")), /*#__PURE__*/React.createElement(BuildABoxCartButton, {
    className: CSSClasses.buttonBuildABox,
    disabled: isLoading
  }), /*#__PURE__*/React.createElement(LookingForSomethingDifferent, null)), /*#__PURE__*/React.createElement(LEWarning, null), isCartEmpty && !isLoading && /*#__PURE__*/React.createElement(EmptyList, {
    title: "Hey, your cart is empty!",
    wrapperClassName: classnames(CSSClasses.emptyList, {
      [CSSClasses.emptyListWithDraft]: isCartEmpty && !isSavedForLaterListEmpty
    }),
    additionalContent: /*#__PURE__*/React.createElement(_Button, {
      color: "primary",
      onClick: instantScrollTop,
      component: AllSwagLink,
      variant: "contained",
      className: classnames(classes.button, CSSClasses.buttonEmptyCart)
    }, "Shop Products")
  }), isLoading ? /*#__PURE__*/React.createElement(ItemSkeletonList, null) : /*#__PURE__*/React.createElement(OrderItemList, null), showSuggestedProductsBeforeSFL && /*#__PURE__*/React.createElement("div", {
    className: CSSClasses.overpaddingWrapper
  }, /*#__PURE__*/React.createElement(SuggestedProductList, {
    imageClassName: CSSClasses.imgClass,
    titleClassName: CSSClasses.title
  })), /*#__PURE__*/React.createElement("div", {
    className: CSSClasses.savedForLaterContainer
  }, !isSavedForLaterListEmpty && /*#__PURE__*/React.createElement("div", {
    className: CSSClasses.overpaddingWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(CSSClasses.savedForLaterWrapper, {
      [CSSClasses.savedDraftIndent]: isCartEmpty && !isSavedForLaterListEmpty
    })
  }, /*#__PURE__*/React.createElement(SavedForLaterList, null))), showSuggestedProductsAfterSFL && /*#__PURE__*/React.createElement(SuggestedProductList, {
    titleClassName: CSSClasses.title
  })), /*#__PURE__*/React.createElement("div", {
    className: classnames({
      [CSSClasses.overpaddingWrapper]: isGreyRecentlyViewed
    })
  }, /*#__PURE__*/React.createElement(RecentlyViewedWidget, null))), !isCartEmpty && !isLoading && /*#__PURE__*/React.createElement("div", {
    className: CSSClasses.checkoutBlock
  }, /*#__PURE__*/React.createElement(CheckoutBlock, {
    className: CSSClasses.background
  })), isLoading && /*#__PURE__*/React.createElement("div", {
    className: CSSClasses.checkoutBlock
  }, /*#__PURE__*/React.createElement(CheckoutBlockSkeleton, {
    className: CSSClasses.background
  }))), /*#__PURE__*/React.createElement(RegularQuantityEditorPopup, null), /*#__PURE__*/React.createElement(SizeEditorPopup, null), /*#__PURE__*/React.createElement(ProductionTimeDialogForItem, {
    isItemEditing: true
  }), /*#__PURE__*/React.createElement(ShareMockupDesignPopup, null), /*#__PURE__*/React.createElement(RegularSizeEditorPopup, null), /*#__PURE__*/React.createElement(RemoveItemFromCartPopup, null), /*#__PURE__*/React.createElement(ItemsValidationConflictPopup, null), /*#__PURE__*/React.createElement(CartBoxesSpecialProductsWarningPopup, null), /*#__PURE__*/React.createElement(OrderMoreDeleteWarningPopup, null), /*#__PURE__*/React.createElement(OrderMoreEditBoxWarningPopup, null), /*#__PURE__*/React.createElement(OrderMoreAddProductsWarningPopup, null), /*#__PURE__*/React.createElement(OrderMoreEditWarningPopup, null), /*#__PURE__*/React.createElement(OrderMoreEditQuantityWarningPopup, null), /*#__PURE__*/React.createElement(CheckoutOutOfStockAdjustmentPopup, null), /*#__PURE__*/React.createElement(CartBoxBuilderPopup, null), /*#__PURE__*/React.createElement(BoxBuilderSelectProductsDrawer, null), /*#__PURE__*/React.createElement(EditQuantityInCartForBuildBoxesDrawer, null), /*#__PURE__*/React.createElement(PreventUnsavedBoxBuilderProgressPopup, {
    route: route
  }), /*#__PURE__*/React.createElement(SuperSpeedBoxConfirmationPopup, {
    route: route
  }), /*#__PURE__*/React.createElement(SuperSpeedBoxTypeChangeConfirmationPopup, {
    route: route
  }), /*#__PURE__*/React.createElement(ConfirmSharedItemsChangesDialog, null), /*#__PURE__*/React.createElement(ConfirmChangeSuperSpeedProdTimePopup, null), /*#__PURE__*/React.createElement(ConfirmTransformSuperSpeedItemsPopup, null), /*#__PURE__*/React.createElement(EditBoxNotecardPopup, null), /*#__PURE__*/React.createElement(BoxNotecardPreventClosePopup, null), /*#__PURE__*/React.createElement(CommentPreBuiltLimitedCartPopup, null), /*#__PURE__*/React.createElement(CommentPreBuiltLimitedCartSuccessPopup, null), /*#__PURE__*/React.createElement(SuperSpeedColorLimitationPopup, null)));
});